/**
 * Charte graphique Safecheck RDC, alignée sur l'accueil et la connexion.
 * Clés historiques conservées : « navy » désigne désormais l'encre sarcelle.
 */
export const brand = {
  lime: "#A6F21B",
  navy: "#1F363C",
  white: "#FFFFFF",
  black: "#000000",
  navyLight: "#5F9DAA",
  navyDark: "#142A2F",
  limeDark: "#6FAE14",
} as const;

/** Couleurs graphiques adaptées au mode sombre */
export const brandDark = {
  lime: "#A6F21B",
  navy: "#86C5D4",
  navyLight: "#A9D6DF",
  navyDark: "#5F9DAA",
  limeDark: "#C6F75C",
} as const;

export const chartPalette = [
  brand.navy,
  brand.lime,
  brand.navyLight,
  brand.limeDark,
  brand.navyDark,
] as const;

export const chartPaletteDark = [
  brandDark.navy,
  brandDark.lime,
  brandDark.navyLight,
  brandDark.limeDark,
  brandDark.navyDark,
] as const;
